import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2 } from "lucide-react";
import { api, asList, errMsg } from "@/lib/api";

const toCsv = (rows, cols) => {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  return [[...cols, "created_at"].join(","), ...rows.map((r) => [...cols, "created_at"].map((c) => esc(r[c])).join(","))].join("\n");
};

export const Submissions = ({ path, cols }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get(path).then((r) => setRows(asList(r))).catch(() => setRows([]));
  useEffect(() => { load(); }, [path]); // eslint-disable-line react-hooks/exhaustive-deps

  const remove = async (id) => {
    if (!window.confirm("Delete this entry?")) return;
    try { await api.delete(`${path}/${id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const exportCsv = () => {
    const url = URL.createObjectURL(new Blob([toCsv(rows, cols)], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url; a.download = `${path.slice(1)}.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <p data-testid={`admin-count-${path.slice(1)}`} className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--muted)]">{rows.length} entries</p>
        <button data-testid={`admin-export-${path.slice(1)}`} onClick={exportCsv} disabled={!rows.length}
          className="inline-flex items-center gap-2 border border-[var(--line)] px-4 py-2.5 font-mono text-xs uppercase tracking-[0.2em] hover:border-[var(--bone)] disabled:opacity-40">
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>
      <div className="mt-4 grid gap-3">
        {rows.map((r) => (
          <div key={r.id} data-testid={`admin-sub-${r.id}`} className="border border-[var(--line)] p-5 bg-[var(--ink-2)] flex gap-4 justify-between">
            <div className="grid sm:grid-cols-3 gap-x-8 gap-y-2 text-sm flex-1 min-w-0">
              {cols.map((c) => (
                <div key={c} className="min-w-0">
                  <span className="field-label block">{c.replace("_", " ")}</span>
                  <span className="break-words">{String(r[c] ?? "") || "—"}</span>
                </div>
              ))}
              <div className="sm:col-span-3 font-mono text-[11px] text-[var(--muted)]">{new Date(r.created_at).toLocaleString()}</div>
            </div>
            <button data-testid={`admin-sub-delete-${r.id}`} onClick={() => remove(r.id)} className="self-start p-2.5 border border-[var(--line)] hover:border-red-400 hover:text-red-400" aria-label="Delete"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
